export const frontendRecoveryStorageKey = 'ych.frontend.assetReloadAt'
export const frontendRecoveryWindowMs = 60_000
export const frontendRecoveryStableDelayMs = 10_000

type RecoveryStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

function errorTexts(error: unknown, visited = new Set<unknown>()): string[] {
  if (error == null || visited.has(error)) return []
  if (typeof error === 'string') return [error]
  if (typeof error !== 'object') return [String(error)]
  visited.add(error)

  const value = error as {
    name?: unknown
    message?: unknown
    cause?: unknown
    payload?: unknown
  }
  const texts = [value.name, value.message]
    .filter((item): item is string => typeof item === 'string' && Boolean(item.trim()))
  return [
    ...texts,
    ...errorTexts(value.cause, visited),
    ...errorTexts(value.payload, visited),
  ]
}

export function isStaleFrontendAssetError(error: unknown): boolean {
  const text = errorTexts(error).join(' | ')
  return [
    /ChunkLoadError/i,
    /Loading chunk [^ ]+ failed/i,
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
    /error loading dynamically imported module/i,
    /Unable to preload CSS/i,
  ].some((pattern) => pattern.test(text))
}

export function claimFrontendRecoveryReload(
  storage: RecoveryStorage = globalThis.sessionStorage,
  now = Date.now(),
): boolean {
  try {
    const previous = Number(storage.getItem(frontendRecoveryStorageKey) || 0)
    if (Number.isFinite(previous) && previous > 0 && now - previous < frontendRecoveryWindowMs) {
      return false
    }
    storage.setItem(frontendRecoveryStorageKey, String(now))
    return true
  } catch {
    return false
  }
}

export function clearFrontendRecoveryReload(
  storage: RecoveryStorage = globalThis.sessionStorage,
): void {
  try {
    storage.removeItem(frontendRecoveryStorageKey)
  } catch {
    // Storage can be unavailable in hardened or private browser contexts.
  }
}
